import AppStore from './apple-store.png';
import PlayStore from './google-play.png';
import Android from './android-button.png';
import AppsScreens from './appscreen.png';
import Background from './bg-header.png';
import Mockup from './mockup.png';

export default {
  AppStore,
  Android,
  PlayStore,
  Background,
  AppsScreens,
  Mockup,
};
